import {
  selHiddenCategoryIds,
  selSuggestedCategoryIds
} from '@features/st-folder-viewer/st-folder-selectors'
import { categorySelectorCategoryGroups } from '@features/st-folder-viewer/st-folder-questionnaire'
import { useReadWriteContext } from '@st/react-util/form-binding'
import { WizardCategoryConfig } from '@st/ui-config'
import { MultiSelectOption } from '@theme'
import { useSelect } from '~/store'

type CategoriesSelectorProps = { sectionId: string }
export function CategoriesSelector({ sectionId }: CategoriesSelectorProps) {
  const hiddenCategoryIds = useSelect('stFolder', selHiddenCategoryIds)

  const categoryGroups = useSelect('stFolder', (s) => {
    if (s.status != 'ready' || s.questionnaire.status != 'ready') return []
    return categorySelectorCategoryGroups(s, sectionId, hiddenCategoryIds)
  })

  const suggestedCategoryIds = useSelect('stFolder', selSuggestedCategoryIds)

  return (
    <div className="flex flex-col gap-10 py-4">
      {categoryGroups.map((section) => {
        return (
          <div key={section.heading}>
            <h2 className="font-lighter bg-white text-lg">{section.heading}</h2>
            <div style={{ height: '15px' }} />
            <div className="flex flex-col gap-5">
              {section.items.map((c) => {
                return (
                  <CategoryToggleButton
                    key={c.id}
                    {...c}
                    noteTip={suggestedCategoryIds.includes(c.id) ? 'Suggested' : undefined}
                  />
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}

function CategoryToggleButton({
  isSelectedUserInputKey,
  name,
  caption,
  tip,
  noteTip
}: WizardCategoryConfig & { noteTip?: string }) {
  const { useRead, useWrite } = useReadWriteContext()
  const value = useRead(isSelectedUserInputKey!)
  const write = useWrite()

  const selected = value === true

  return (
    <MultiSelectOption
      caption={caption ?? undefined}
      tip={tip}
      selected={selected}
      noteTip={noteTip}
      onClick={() => write({ [isSelectedUserInputKey!]: !selected })}
    >
      {name}
    </MultiSelectOption>
  )
}
